import { render, staticRenderFns } from "./Background1.vue?vue&type=template&id=ef1e47cc&"
import script from "./Background1.vue?vue&type=script&lang=js&"
export * from "./Background1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports